module.exports = __webpack_public_path__ + "img/31200.a4e7492f.jpg";